import styled from 'styled-components';

export const BlogPageWrapper = styled.main`
	min-height: calc(100vh - 700px);
`;

export const FooterWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.grey[100]};
`;
